/**
 * simple model representing an html option
 */
export interface HtmlOption {
  value: string;
  label: string;
}
